import { IconCheckCircle } from "@assets/icons";
import { APP_INSTALLER_HEIGHT, HEADER_HEIGHT, Paths } from "@constants";
import useTypedSelector from "@hooks/useTypedSelector";
import { useMemo } from "react";
import { Toaster as RawToaster } from "react-hot-toast";
import { matchPath, useLocation } from "react-router-dom";

const NONE_HEADER_PATHS = [
  Paths.PRIVATE.AUTH_BANK_ACCOUNT_PAGE,
  Paths.PRIVATE.AUTH_RESET_PAGE,
  Paths.PRIVATE.DEPOSIT_CALLBACK,
  ...Object.values(Paths.PUBLIC),
];

const Toaster = () => {
  const pathname = useLocation().pathname;
  const isDisplayAppInstaller = useTypedSelector((state) => state.preferences.isDisplayAppInstaller);

  const hasHeader = useMemo(() => {
    return !NONE_HEADER_PATHS.some((route) => matchPath(route, pathname));
  }, [pathname]);

  const topOffset = useMemo(() => {
    let baseOffset = 0;
    if (isDisplayAppInstaller) baseOffset += APP_INSTALLER_HEIGHT;
    if (hasHeader) baseOffset += HEADER_HEIGHT;
    return baseOffset + "px";
  }, [hasHeader, isDisplayAppInstaller]);

  return (
    <RawToaster
      toastOptions={{
        duration: 3000,
        style: {
          color: "white",
          borderRadius: "6px",
          fontSize: "14px",
          padding: "4px 8px 4px 8px",
          alignItems: "center",
          boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.2)",
        },
        className: "custom-toast !bg-darkBrand-950 border border-stroke-base",
        success: {
          icon: <IconCheckCircle />,
        },
      }}
      containerStyle={{
        marginTop: topOffset,
      }}
      containerClassName="transition-[margin-top] ease-in-out duration-300"
    />
  );
};

export default Toaster;
